module.exports = __webpack_public_path__ + "Body_Normal.242b7f6.basis";